import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import CreateCustomer from "../pages/Customer/CreateCustomer";
import CustomerList from "../pages/Customer/CustomerList";
import EditCustomer from "../pages/Customer/EditCustomer";
//@ts-ignore
import { AccessControl ,PermissionRequired} from "@careinfo/permission-required";

export const queryClient = new QueryClient()

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path="/" element={<CustomerList />} />
          <Route path="/customer" element={<CustomerList />} />
          <Route path="/create" element={
            <AccessControl
            children={
            <CreateCustomer />
            }
            allowedPermissions={["can_create_customer"]}
            renderNoAccess={<PermissionRequired/>}
            />
          } />
          <Route path="/edit/:id" element={
              <AccessControl
              children={
                <EditCustomer />
              }
              allowedPermissions={["can_update_customer"]}
              renderNoAccess={<PermissionRequired/>}
              />
           } />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>

  );
};

export default Router;